




















































import { Component, Prop, Vue } from "vue-property-decorator";
import ShiftRender from "@/components/render/ShiftRender.vue";
import MenuRender from "@/components/render/MenuRender.vue";
import { RenderChannelModel, RenderPostModel } from "@/services/render/types";
import { renderChannel } from "@/services/render/renderService";
import { Getter } from "vuex-class";
import PreviewFullScreenHeader from "@/components/common/preview/PreviewFullScreenHeader.vue";
import { InteractionTypes, isShift } from "@/services/channels/types";
import PreviewSidebar from "@/components/common/preview/PreviewSidebar.vue";
import SolutionRender from "@/components/render/SolutionRender.vue";
import { Solution } from "@/services/solutions/types";
const namespace: string = "authentication";

@Component({
    components: {
        ShiftRender,
        PreviewFullScreenHeader,
        MenuRender,
        PreviewSidebar,
        SolutionRender
    }
})
export default class ChannelPreview extends Vue {
    @Prop() private channelId!: string;
    @Getter("getToken", { namespace }) getToken!: string;

    // local state
    shiftRenderModel = {
        height: 0,
        width: 0,
        renderPosts: [] as Array<RenderPostModel>
    } as RenderChannelModel;

    interactionTypes = InteractionTypes;
    shiftRenderReload = 0;
    scale = 1;
    dateTime = "";
    fitScale = 0;
    bgColor = "#ffffff";
    isShift = isShift;

    // lifecycle hooks

    created() {
        this.channelId = this.channelId
            ? this.channelId
            : this.$route.params.channelId;
    }

    renderChannel(value: string, keepZoom = false) {
        this.dateTime = value;
        renderChannel(this.channelId, this.dateTime).then(
            response => {
                this.shiftRenderReload += 1;
                this.shiftRenderModel = response;
                (this.$refs.header as any).setBackTitle(response.name);
                const oldScale = this.scale;
                this.setScale(this.shiftRenderModel.width, this.shiftRenderModel.height);
                if (keepZoom) this.scale = oldScale;
                if (this.shiftRenderModel.renderPosts[0]) (this.$refs.header as any).checkBackgroundColor(this.shiftRenderModel.renderPosts[0]);
            }
        );
    }

    setScale(width: number, height: number) {
        var scaleX = (window.innerWidth / 100 * 95) / width;
        var scaleY = (window.innerHeight / 100 * 88) / height;
        this.scale = scaleX <= scaleY ? scaleX : scaleY;
        this.scale = this.scale >= 1 ? 1 : this.scale;
        this.scale = Math.floor(this.scale * 100) / 100;
        this.fitScale = this.scale;
    }

    scaleFit() {
        this.scale = this.fitScale;
    }

    onScale(value: number) {
        this.scale = value;
    }

    changeBg(color: string) {
        this.bgColor = color;
    }

    // computed
    get model(): RenderChannelModel {
        if (this.shiftRenderModel.renderPosts.length > 0) {
            return this.shiftRenderModel;
        } else {
            return undefined!;
        };
    }

    get adaptedSize() {
        return {
            transform: "scale(" + this.scale + ")",
            "transform-origin": "left top",
            height: `${this.shiftRenderModel.height}px`,
            width: `${this.shiftRenderModel.width}px`
        };
    }

    // solution preview
    solutionPreview = false;
    selectedSolution = {} as Solution;

    loadSolutionPreview(solution: Solution) {
        this.selectedSolution = solution;
        this.setScale(this.selectedSolution.width, this.selectedSolution.height);
        this.solutionPreview = true;
    }

    clearSolutionPreview() {
        this.selectedSolution = {} as Solution;
        this.setScale(this.shiftRenderModel.width, this.shiftRenderModel.height);
        this.solutionPreview = false;
    }

    get solutionAdaptedSize() {
        return {
            transform: "scale(" + this.scale + ")",
            "transform-origin": "left top",
            height: `${this.selectedSolution.height}px`,
            width: `${this.selectedSolution.width}px`
        };
    }
}
